<template>
    <li class="ProductIcon" @click="$emit('click', option)">
        <span
            :id="'ProductImage_' + option.name"
            :class="{ selected: selected.includes(option.name), core: !!option.core }"
            :title="$t(option.label)"
            class="ProductImage"
        >
        </span>
        <template v-if="nameParts.length === 2"> {{ nameParts[0] }}<br />{{ nameParts[1] }} </template>
        <template v-else-if="nameParts.length === 3">
            {{ nameParts[0] }} {{ nameParts[1] }}<br />{{ nameParts[2] }}
        </template>
        <template v-else>
            {{ $t(option.label) }}
        </template>
    </li>
</template>

<script>
    export default {
        name: 'MenuIcon',
        props: {
            option: {
                type: Object,
                required: true,
            },
            selected: {
                type: Array,
                required: true,
            },
        },
        emits: ['click'],
        computed: {
            nameParts() {
                return this.$t(this.option.label).split(' ');
            },
        },
    };
</script>
